module.exports = __webpack_public_path__ + "static/media/map-marker-times.e61ec9ac.svg";